import React, {Component} from 'react';
import moment from 'moment';
import {withRouter} from "react-router-dom";
import {Button, Grid, Header, Icon, List, Message, Popup, Segment} from "semantic-ui-react";
import {CustomContainer} from '../custom-common';
import {connect} from "react-redux";
import axios from "axios";
import {
    CHANGE_ROUTE,
    convertServerDateFormatToDisplay,
    documentTypes,
    dowloadBase64,
    formatMoneyAmount,
    getNumberOfDeductions,
    memberName,
    resolveDisplayTier,
} from "../../utils/common";
import {setClaimant} from "../../actions/newClaimActions";
    import CoveredModal from "../coveredModal";
import {delay, dowloadBlob, getPayrollFrecuencyLabel, resolveErrorMessage} from "../../utils/utils";
import {PAYROLL_FREQUENCIES} from "../../constants/payrollFrequencies";
import STRATEGIC_PARTNER from "../../constants/strategicPartners";
import {S3Image} from "../custom-common";
import {CustomDivider} from "../custom-common";
import BenefitLimits from "./benefitLimits";
import WaitingPeriods from "./waitingPeriods";
import Benefits from "./benefits";


const mapStateToProps = ({initialData, auth}, ownProps) => {
    const id = initialData || {};
    const contract = initialData?.contract || {};
    const riderLabels = initialData.riderLabels
    const groupSizeSegment = contract?.groupSizeSegment;

    return {
        ...ownProps,
        dependents: id.dependents,
        certificateHolder: id.certificateHolder,
        user: id.user,
        benefits: id.certificate.assetCoverages,
        limitations: id.limitations,
        documents: id.documents,
        certificate: id.certificate,
        payrollFrequency: id.payrollFrequency,
        cost: id.cost,
        employerContribution: id.employerContribution,
        userIsCertificateHolder: id.userIsCertificateHolder,
        contract: id.contract,
        stateCode: contract.issueState,
        groupSizeSegment: groupSizeSegment,
        policyNumber: contract.policyNumber,
        employer: initialData.employer,
        riderLabels,
    }
};

class PlanSummary extends Component {
    state = {
        loading: true,
        docsLoading: false,
        docsError: null,
        displayTier: null,
        displayPayrollFrecuency: null,
        displayCoveredModal: false
    }

    doDisplayCoveredModal = (status) => {
        let {displayTipsModal} = this.state;
        if (status) {
            displayTipsModal = false;
        }
        this.setState({
            displayTipsModal,
            displayCoveredModal: status,
        });
    }

    componentDidMount() {
        this.setState({
            loading: false,
            displayTier: !!this.props.certificate ? resolveDisplayTier(this.props.certificate.familyTier) : '',
            displayPayrollFrecuency: getPayrollFrecuencyLabel(this.props.payrollFrequency, true)
        })
    }

    handleChange = (claimant) => {
        this.props.dispatch(setClaimant(claimant))
        this.props.history.push("/claims/new")
    }

    findDocument = (type) => {
        const {documents} = this.props
        if (!!documents) {
            for (const doc of documents) {
                if (doc.documentType === type) {
                    return doc
                }
            }
        }
        return null
    }

    downloadDoc = async (doc) => {
        try {
            this.setState({docsLoading: true, docsError: null})
            const result = await axios.post("/api/member/v2/downloadDocument", {"documentId": doc.documentId}, {headers: {'Content-Type': 'application/json'}});
            const data = result.data;
            dowloadBase64(data.document.name, data.document.contentType, data.document.body)
            this.setState({docsLoading: false})
        } catch (e) {
            console.warn(e)
            this.setState({docsLoading: false, docsError: "Unable to get the document"})
        }
    }

    change = () => {
        const {certificate, contract} = this.props;
        if (!!certificate.useBrellaEnrollment && contract.planOffering !== "Brella Select Custom") {
            this.props.history.push(CHANGE_ROUTE)
        } else {
            this.props.history.push("/benAdmin")
        }
    }

    downloadCoveragePacket = async () => {
        const { stateCode, groupSizeSegment, policyNumber, employer } = this.props

        this.setState({docsLoading: true, docsError: null})

        try {
            const payload = {
                employerId: employer.id,
                stateCode,
                groupSizeSegment,
                policyNumber,
            }

            let result
            let status

            result = await axios.post('/api/member/v2/generateCoveragePacket', payload)
            status = result.data.status

            while (status === 'pending') {
                await delay(4000)
                result = await axios.post('/api/member/v2/isCoveragePacketGenerated', payload)
                status = result.data.status
            }

            if (status !== 'success') return this.setState({
                docsLoading: false,
                docsError: 'Unable to get the document'
            })

            result = await axios.post('/api/member/v2/downloadCoveragePacket', payload, { responseType: 'blob' })
            const data = result.data
            let packetName = result.headers["x-packetname"];
            if(!packetName){
                const date = moment().format('YYYY-MM-DD')
                packetName = `coverage-packet-${date}.pdf`;
            }
            dowloadBlob(packetName, 'application/pdf', data)
            this.setState({ docsLoading: false })
        } catch (e) {
            this.setState({
                docsLoading: false,
                docsError: resolveErrorMessage(e, 'Unable to get the document')
            })
        }
    }

    get downloadIcon() {
        return (
            <Icon
                name='download'
                style={{
                    color: '#43806C',
                    position: 'absolute',
                    top: '14px',
                    right: '6px',
                }}
            />
        )
    }

    get pdfIcon() {
        return (
            <Icon
                name="file pdf outline"
                color="red"
                size="large"
                style={{ position: 'absolute', left: '1.5rem', top: '2rem' }}
            />
        )
    }

    render() {
        const {
            docsLoading,
            docsError,
            displayTier,
            displayPayrollFrecuency,
            displayCoveredModal
        } = this.state;
        const {
            dependents,
            user,
            benefits,
            payrollFrequency,
            limitations,
            employerContribution,
            cost,
            userIsCertificateHolder,
            certificate,
            riderLabels,
        } = this.props;
        const groupAppDoc = this.findDocument(documentTypes.groupApplication)
        const {contractTerms} = certificate.ratedClass;

        const infoIcon = <Icon className={'nonprintable'} circular name={'info'}
                               style={{color: 'black', marginLeft: '1em', fontSize: '10px', cursor: 'pointer'}}
                               onClick={() => this.setState({displayInformationAboutCategoriesModal: true})}/>;
        const costsTooltipText = !!payrollFrequency ? `Estimated based on a payroll frequency of ${getNumberOfDeductions(payrollFrequency)} payroll deductions per year, and may not match
                                    exact payroll withdrawals. Contractual premiums are on a monthly basis.` : null;


        const displayInfoIconIfNecessary = () => {
            if (payrollFrequency === PAYROLL_FREQUENCIES.MONTHLY_12) return null;

            return (
                <Popup className="greenPopup" on="hover" position="top left"
                       trigger={<span style={{display: 'flex'}}>{infoIcon}</span>}>
                    <span className="smaller">{costsTooltipText}</span>
                </Popup>
            );
        };

        return (<>
                <CoveredModal displayCoveredModal={displayCoveredModal}
                              onModalClose={() => this.doDisplayCoveredModal(false)}
                />
                <p className={"small"}><b>Note:</b> This is a summary of the important features of your
                    coverage. This is not the insurance contract. Please refer to your certificate below for all
                    details including the rights and obligations of both you and {STRATEGIC_PARTNER.LABEL}.</p>
                <CustomDivider hidden />
                <Header as="h2">Coverage</Header>
                {!!certificate &&
                <p className={"small"}>Effective {convertServerDateFormatToDisplay(certificate.effectiveDate)}</p>}
                <Button data-qa-button_condition primary basic compact onClick={() => {
                    this.setState({displayCoveredModal: true})
                }}>Condition lookup</Button>
                <CustomDivider small hidden/>
                <Benefits benefits={benefits} riderLabels={riderLabels} infoIcon={infoIcon} />
                {!!userIsCertificateHolder && <>
                    <CustomDivider hidden/>
                    <Header as="h2">Family info</Header>
                    <Grid>
                        <Grid.Column width={4}>
                            <p>
                                <b>Tier</b><br/>
                                {displayTier}
                            </p>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <div>
                                <div><b>Covered</b></div>
                                <div>{memberName(user)}</div>
                                {(!!dependents && dependents.length > 0) && dependents.map((item, i) => {
                                    return <div key={i}>{item.firstName} {item.lastName}</div>
                                })}
                            </div>
                        </Grid.Column>
                    </Grid>
                </>
                }


                {!!userIsCertificateHolder && <>
                    <CustomDivider section/>

                    <Header as="h2">Costs</Header>
                    <CustomDivider hidden small/>
                    <Grid>
                        <Grid.Column width={6}>
                            {
                                formatMoneyAmount(cost) === "0.00"
                                    ? (
                                        <CustomContainer padded
                                                 style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <S3Image name={"icon_100_percent"} width={80} centered/>
                                            <b style={{marginLeft: '25px'}}>Your {STRATEGIC_PARTNER.LABEL} coverage is paid for by your
                                                employer.</b>
                                        </CustomContainer>
                                    ) : (
                                        <>
                                            <CustomContainer data-qa-cost_info padded>
                                                <span className={"pineGreenText"}><b>I pay</b></span>
                                                <Header as={"h2"} className={"neutral900Text"} style={{display: 'flex', alignItems: 'center'}}>
                                                    <span>${formatMoneyAmount(cost)}/{displayPayrollFrecuency}</span>
                                                    {displayInfoIconIfNecessary()}
                                                </Header>
                                            </CustomContainer>
                                            {employerContribution > 0 && <p data-qa-cost_contribution className={"pineGreenText"}>Employer contributes
                                                ${formatMoneyAmount(employerContribution)}/{displayPayrollFrecuency}</p>}
                                        </>
                                    )
                            }
                        </Grid.Column>
                    </Grid>
                </>
                }

                <CustomDivider section/>

                <Header as="h2">Policy document(s)</Header>
                {docsError && <Message error> {docsError}</Message>}
                <Grid basic stackable columns={2} as={Segment} loading={docsLoading}>
                    <Grid.Column className={"no-padding"}>
                        <CustomContainer
                            data-qa-pdf_coverage
                            className={"hovereable clickable"}
                            onClick={this.downloadCoveragePacket}
                        >
                            {this.pdfIcon}
                            <CustomContainer basic compact vertical style={{ marginLeft: '48px'}}>
                                <b>Coverage packet</b>{this.downloadIcon}
                                <p className={"smaller truncate-3"} style={{ minHeight: '40px', marginTop: '8px', width: '90%' }}>
                                    This includes the limited benefit insurance certificate,
                                    HIPAA notice of privacy practices and more.
                                </p>
                            </CustomContainer>
                        </CustomContainer>
                    </Grid.Column>
                    {groupAppDoc && (
                        <Grid.Column>
                            <CustomContainer
                                className={"hovereable clickable"}
                                onClick={() => { this.downloadDoc(groupAppDoc)}}
                            >
                                {this.pdfIcon}
                                <CustomContainer basic compact vertical style={{ marginLeft: '48px'}}>
                                    <b>Group application</b>{this.downloadIcon}
                                    <p className={"smaller truncate-3"} style={{ minHeight: '40px', marginTop: '8px', width: '90%' }}>
                                        The approved limited benefit policyholder application submitted for your group's policy.
                                    </p>
                                </CustomContainer>
                            </CustomContainer>
                        </Grid.Column>
                    )}

                </Grid>

                <CustomDivider section/>

                <BenefitLimits />

                <CustomDivider section/>

                <Header as="h2">Limitations and exclusions</Header>
                <p>A complete description of benefits, limitations, and exclusions will be provided in your
                    certificate of Insurance and applicable Riders. All coverage is subject to the terms and
                    conditions of the master group policy. We’ve provided a summary below.</p>

                <CustomDivider hidden/>

                {limitations.length && <>
                    <p><b>Exclusions</b></p>

                    {limitations.map((item, key) => (
                    <div key={key}>
                        <p>{item.title}</p>
                        <List ordered style={{marginLeft: '2em', marginBottom: '2em', fontWeight: 'bold'}}>
                            {item.items.map((val, key) => (
                                <List.Item key={key}><span style={{fontWeight: 'normal'}}>{val.title}</span></List.Item>
                            ))}
                        </List>
                    </div>))}
                </>}


                {(!!contractTerms && !!contractTerms.ageReduction) && <><p>
                    <b>Reductions of coverage</b><br/>
                    Benefits will be reduced at ages beyond standard retirement age. At
                    age {contractTerms.ageReductionAge}, your benefits
                    reduce by {contractTerms.ageReductionPercentage}%.
                </p>
                    <CustomDivider hidden/>
                </>
                }

                <WaitingPeriods />
                <CustomDivider hidden/>
                <p>
                    <b>Renewability, cancellation, & termination</b><br/>
                    This coverage is offered under a group policy, and is annually renewable. Your continued coverage depends on
                    whether your employer renews the group policy. If your employer does not renew the policy,
                    coverage ends for all employees.&nbsp;

                    {(!!contractTerms && !!contractTerms.portability && contractTerms.portability !== 'Excluded') && <>
                        <span>You may be eligible to continue, or “port”, your coverage if you leave your
                        employer or if your employer discontinues the group policy. </span>
                    </>}

                    If your employer renews the policy, you will have the
                    option to continue your coverage. Premiums may change on the policy anniversary and your
                    employer’s contribution to policy premiums may also change. You may choose to terminate
                    coverage before the next policy anniversary by letting your employer know your choice in
                    writing.
                </p>
            </>
        )
    }
}

export default connect(mapStateToProps)(withRouter(PlanSummary));
